module.exports = __webpack_public_path__ + "img/walk-get.2300846a.png";